module.exports = __webpack_public_path__ + "img/label-pl.bb3dae01.png";